<template>
    <div class="modal-content">
        <div class="modal-header bg-1">
            <div class="modal-title mb-0 mb-md-2">
                <h2 class="h3 mb-0">Przetwarzanie...</h2>
            </div>
            <modal-close @click.native="resetSettlementsProgressBar" />
        </div>
        <div class="modal-body p-5 text-center">
            <h3 class="h4 mt-0" v-if="finished">
                Dokumenty zostały przetworzone.
            </h3>
            <h3 class="h4 mt-0" v-else>Trwa przetwarzanie dokumentów.</h3>
            <p v-if="!finished" class="h4 mt-1">Proszę czekać.</p>

            <progress-bar class="m-5" :bar-width="percentage" />

            <h3 class="h5 mb-0">
                Przetworzono {{ processed }} z {{ total }} dokumentów.
            </h3>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        progressBar() {
            return this.$store.getters.getSettlementsProgressBar
        },
        total() {
            return this.progressBar.total_count
        },
        processed() {
            return this.progressBar.processed_count
        },
        percentage() {
            return this.progressBar.percentage
        },
        finished() {
            return this.progressBar.finished
        }
    },
    methods: {
        resetSettlementsProgressBar() {
            this.$store.dispatch('resetSettlementsProgressBar')
        }
    },
    watch: {
        finished() {
            if (this.finished) {
                setTimeout(() => {
                    this.resetSettlementsProgressBar()
                    this.$store.dispatch('toggleModal', false)
                }, 1000)
            }
        }
    }
}
</script>
